import { Link } from "@tanstack/react-router";
import { Droplets } from "lucide-react";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          className="flex items-center gap-2.5 group"
          aria-label="Bevattningskartan startsida"
        >
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary text-primary-foreground transition-transform group-hover:scale-105">
            <Droplets className="h-5 w-5" strokeWidth={2.2} />
          </span>
          <span className="font-display text-xl tracking-tight text-foreground">
            Bevattningskartan
          </span>
        </Link>
        <nav className="flex items-center gap-1 text-sm font-medium">
          <Link
            to="/api"
            className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground [&.active]:text-foreground"
          >
            API
          </Link>
          <Link
            to="/kallor"
            className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground [&.active]:text-foreground"
          >
            Källor
          </Link>
          <Link
            to="/faq"
            className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground [&.active]:text-foreground"
          >
            FAQ
          </Link>
          <Link
            to="/om"
            className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground [&.active]:text-foreground"
          >
            Om
          </Link>
        </nav>
      </div>
    </header>
  );
}
